import React, { useState } from 'react';
import { API_ENDPOINTS } from '../config';
import './Career.css';

const Career = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const formData = new FormData(e.target);
    const resumeFile = formData.get('resume');
    
    // Check if resume is uploaded
    if (resumeFile && resumeFile.size === 0) {
      alert('Please upload your resume');
      setIsSubmitting(false);
      return;
    }
    
    // Check file size (5MB limit)
    if (resumeFile && resumeFile.size > 5 * 1024 * 1024) {
      alert('Resume file size must be less than 5MB');
      setIsSubmitting(false);
      return;
    }
    
    // Check file type
    if (resumeFile && !['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(resumeFile.type)) {
      alert('Please upload a PDF or DOC file');
      setIsSubmitting(false);
      return;
    }
    
    try {
      const response = await fetch(API_ENDPOINTS.career, {
        method: 'POST',
        body: formData, // Send FormData directly, not JSON
      });

      const result = await response.json();

      if (result.success) {
        e.target.reset();
        setSelectedFile(null);
        
        // Show success message
        const successMsg = document.querySelector('.success-msg');
        if (successMsg) {
          successMsg.style.display = 'block';
          setTimeout(() => {
            successMsg.style.display = 'none';
          }, 5000);
        }
      } else {
        alert('Failed to submit application. Please try again later.');
      }
    } catch (error) {
      console.error('Error submitting application:', error);
      alert('An error occurred. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="career-page">
      {/* HERO */}
      <section className="career-hero">
        <div className="hero-bg"></div>
        <div className="hero-bg-dots"></div>
        <div className="hero-blob blob1"></div>
        <div className="hero-blob blob2"></div>

        <div className="hero-content">
          <div className="s-tag">
            Career Opportunities
          </div>
          <h1>Opportunities That<br/><span>Match Your Potential</span></h1>
          <p>
            We go beyond traditional hiring. Our AI-powered system scans your profile and connects you with opportunities aligned to your expertise. Receive personalized job recommendations directly to your contact details.
          </p>
          <div className="hero-actions">
            {/* <button className="btn-primary">Explore Opportunities</button> */}
            <button className="btn-outline" onClick={() => document.getElementById('form-section').scrollIntoView({behavior: 'smooth'})}>
              Get Matched Now
            </button>
          </div>
        </div>
      </section>

      {/* WHY JOIN */}
      <section className="s">
        <div className="container">
          <div className="s-tag" style={{justifyContent:"start"}}>Why Krishpar</div>
          <h2>A Place Where <em>Careers Grow</em></h2>
          <p className="intro">
            At Krishpar, we believe the best outcomes come from empowered people. We invest in our team as much as we invest in our clients.
          </p>
          
          <div className="perks-grid">
            <div className="perk">
              <div className="perk-icon">🚀</div>
              <h3>High-Impact Work</h3>
              <p>Every role at Krishpar directly shapes how hundreds of businesses hire, manage, and pay their workforce. Your work matters from day one.</p>
            </div>
            <div className="perk">
              <div className="perk-icon">📈</div>
              <h3>Rapid Growth</h3>
              <p>We're a fast-growing company with growing service lines. There's always a new challenge, a new responsibility, and a new opportunity to level up.</p>
            </div>
            <div className="perk">
              <div className="perk-icon">🤝</div>
              <h3>Collaborative Culture</h3>
              <p>No unnecessary hierarchy. Ideas from anywhere get heard. We move fast, learn from each other, and celebrate wins together as a team.</p>
            </div>
            <div className="perk">
              <div className="perk-icon">🧠</div>
              <h3>Learning & Development</h3>
              <p>Access to industry certifications, training programmes, and mentorship from experienced HR and technology professionals across the organisation.</p>
            </div>
            <div className="perk">
              <div className="perk-icon">📍</div>
              <h3>Chennai Base, India Vision</h3>
              <p>Headquartered in Mogappair West, Chennai — with projects spanning clients across India, GCC, and growing. Think global, work local.</p>
            </div>
            <div className="perk">
              <div className="perk-icon">💼</div>
              <h3>Competitive Packages</h3>
              <p>Market-aligned compensation, performance incentives, and benefits that reflect the value you bring to team and our clients.</p>
            </div>
          </div>
        </div>
      </section>

      {/* APPLICATION FORM */}
      <section className="form-section" id="form-section">
        <div className="form-wrap">
          <div className="form-header">
            <div className="s-tag">Apply Now</div>
            <h2>Tell Us About Yourself</h2>
            <p className="intro">
              Fill in your details below and our team will get back to you. You can also reach us directly at <a href="mailto:connect@krishpar.com">connect@krishpar.com</a>
            </p>
          </div>
          
          <form onSubmit={handleSubmit} className="career-form">
            <div className="form-group">
              <label>Full Name *</label>
              <input type="text" name="name" placeholder="Your full name" required />
            </div>
            
            <div className="form-group">
              <label>Phone Number *</label>
              <input type="tel" name="phone" placeholder="+91 99624 55328" required />
            </div>
            
            <div className="form-group">
              <label>Email Address *</label>
              <input type="email" name="email" placeholder="you@company.com" required />
            </div>
            
            <div className="form-group">
              <label>Current Location *</label>
              <input type="text" name="location" placeholder="City, State" required />
            </div>
            
            <div className="form-group full">
              <label>Role / Position Interested In *</label>
              <input type="text" name="role" placeholder="Describe the role or position you're interested in..." required />
            </div>
            
                        
            <div className="form-group full">
              <label>Upload Resume (PDF, DOC — Max 5MB)</label>
              <div className={`upload-zone ${selectedFile ? 'has-file' : ''}`}>
                <input 
                  type="file" 
                  name="resume" 
                  accept=".pdf,.doc,.docx" 
                  onChange={handleFileChange}
                />
                <div className="upload-icon">{selectedFile ? '?' : '?'}</div>
                <div className="upload-text">
                  {selectedFile ? (
                    <div>
                      <strong>Selected file:</strong><br/>
                      {selectedFile.name}<br/>
                      <span style={{ fontSize: '0.9em', color: '#666' }}>
                        ({(selectedFile.size / 1024 / 1024).toFixed(2)} MB)
                      </span>
                    </div>
                  ) : (
                    <>
                      <strong>Click to upload</strong> or drag and drop<br/>
                      PDF, DOC or DOCX · Max 5 MB
                    </>
                  )}
                </div>
              </div>
            </div>
            
            <div className="form-submit">
              <button type="submit" className="btn-submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <span className="spinner"></span>
                    Submitting...
                  </>
                ) : (
                  'Submit Application'
                )}
              </button>
            </div>
            
            <div className="form-note">
              By submitting this form, you consent to Krishpar Technologies contacting you regarding career opportunities. We respect your privacy and will never share your details with third parties.
            </div>
            
            <div className="success-msg">
              <h3>✅ Application Received!</h3>
              <p>Thank you for your interest in Krishpar Technologies. Our team will review your application and reach out to you at the contact details provided. You can also write to us at <strong>connect@krishpar.com</strong></p>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Career;
